export default function ErrorScreen({ message, onBack }) {
  return (
    <div className="min-h-dvh flex flex-col items-center justify-center px-4 gap-4">
      <div className="text-center max-w-sm animate-fade-in">
        <div className="text-4xl mb-4 opacity-40">⚠</div>
        <h2 className="font-display text-2xl font-semibold text-ivory-50 mb-2">Something went wrong</h2>
        <p className="text-ivory-300/50 text-sm mb-6 leading-relaxed">{message}</p>
        {onBack && (
          <button onClick={onBack} className="btn-secondary">
            ← Back to Home
          </button>
        )}
      </div>
    </div>
  )
}
